var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w-full" },
    [
      _vm.isRequestContractorShown
        ? _c("AddContractorToCompany", {
            attrs: {
              buttonVariant: "black",
              buttonSize: "xxs",
              fullWidth: "",
              buttonText: _vm.isPublic ? "Get Access" : "Request access",
              companyName: _vm.companyName,
              companyId: _vm.companyId,
              contractorUserId: _vm.contractorUserId,
              currentUserId: _vm.currentUserId,
              isPublic: _vm.isPublic,
            },
            on: {
              addedToCompany: function ($event) {
                return _vm.$emit("cardDataUpdated")
              },
              "update:isPublic": function ($event) {
                _vm.isPublic = $event
              },
              "update:is-public": function ($event) {
                _vm.isPublic = $event
              },
            },
          })
        : _vm._e(),
      _vm.isContractorRequested
        ? _c("RemoveManagerContractorRequest", {
            attrs: {
              fullWidth: "",
              buttonVariant: "outline",
              buttonSize: "xxs",
              contractorId: _vm.contractorId,
              managerId: _vm.managerId,
            },
            on: {
              requestRemoved: function ($event) {
                return _vm.$emit("cardDataUpdated")
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }